import { SiteControllerType } from "@/lib/gql/__generated__/graphql";

type Props = {
	siteControllerType: SiteControllerType;
	setUpRoomPriceByChillnn: boolean | null | undefined;
};

/**
 * SC連携プランは「サイコン連携していて、CHILLNNで部屋料金を管理していない」ことが前提。
 * CHILLNNで部屋料金を管理している（setUpRoomPriceByChillnn）ホテルでは、
 * プラン単位のSC連携は成立しないためトグル自体を出さない（ねっぱん・手間いらず共通）。
 */
export const shouldShowScConnectedToggle = ({ siteControllerType, setUpRoomPriceByChillnn }: Props): boolean => {
	if (setUpRoomPriceByChillnn ?? false) {
		return false;
	}
	return siteControllerType === SiteControllerType.Neppan || siteControllerType === SiteControllerType.Temairazu;
};
